import { render, staticRenderFns } from "./CardRating.vue?vue&type=template&id=2b17ad3f"
import script from "./CardRating.vue?vue&type=script&lang=ts"
export * from "./CardRating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b17ad3f')) {
      api.createRecord('2b17ad3f', component.options)
    } else {
      api.reload('2b17ad3f', component.options)
    }
    module.hot.accept("./CardRating.vue?vue&type=template&id=2b17ad3f", function () {
      api.rerender('2b17ad3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rating/CardRating.vue"
export default component.exports